
<div class="loader"></div>
<div id="appCapsule">
   <div id="livePage">     
      <div class="container">
         <div id="result" class="resultStyle">
         </div>
         <div id='lastUpdateDate' class="updateTimeStyle" style="margin-top: 64px;">
         </div>

      </div>

      <div class="container mt-2">        
         <div id="section-container">
          
         </div>
         <div id="modern-container"></div>
      </div>

   </div>
</div>